export const UNSUPPORTED_STRIPE_COUNTRIES = ['AR', 'CL', 'CO', 'EC', 'IL', 'PH', 'ZA'];

export function getStripeAppearanceConfig(theme) {
    return {
        rules: {
            '.Input:focus': {
                borderColor: theme.colors.blue[500],
                boxShadow: `0 0 0 1px ${theme.colors.blue[500]}`
            },
            '.Label': {
                fontSize: '14px'
            }
        },
        variables: {
            colorPrimary: theme.colors.blue[500],
            colorText: theme.fontColor?.default ?? theme.colors.navy[400],
            fontFamily: theme.fonts.body,
            fontSmooth: 'auto',
            fontSizeBase: '14px',
            gridRowSpacing: '8px'
        }
    };
}

export function getStripeCheckoutAppearanceConfig(theme) {
    return {
        rules: {
            '.Checkbox': {
                color: theme.isLightColorScheme ? theme.colors.gray[500] : theme.colors.white,
                fontSize: '14px'
            },
            '.Input:focus': {
                borderColor: theme.colors.brand.primary,
                borderWidth: '2px',
                boxShadow: 'none'
            },
            '.Label': {
                color: theme.isLightColorScheme ? theme.colors.gray[500] : theme.colors.white,
                fontSize: '14px'
            }
        },
        variables: {
            fontFamily: 'OpenSans-Regular,Tahoma,sans-serif',
            colorPrimary: theme.colors.brand.primary
        }
    };
}

export function getStudioFontsForStripeElements(staticUrl: string) {
    return [
        {
            family: 'azo-sans-web',
            src: `url("${staticUrl}/common/font/azosans-light.otf")`,
            weight: 'lighter'
        },
        {
            family: 'azo-sans-web',
            src: `url("${staticUrl}/common/font/azosans-medium.otf")`,
            weight: 'bold'
        },
        {
            family: 'azo-sans-web',
            src: `url("${staticUrl}/common/font/azosans.otf")`,
            weight: 'normal'
        }
    ];
}

export function getTranslationKeyForStripeError(stripeError?: string) {
    let translationKey = '';

    switch (stripeError) {
        case 'card_declined':
            translationKey = 'cardDeclined';
            break;

        case 'expired_card':
            translationKey = 'expiredCard';
            break;

        case 'incorrect_cvc':
            translationKey = 'incorrectCvc';
            break;

        case 'incorrect_number':
            translationKey = 'incorrectNumber';
            break;

        case 'processing_error':
            translationKey = 'processingError';
            break;

        default:
            translationKey = 'otherError';
    }

    return translationKey;
}

export const inputStyles = {
    _autofill: {
        boxShadow:
            'rgba(0, 0, 0, 0.03) 0px 1px 1px 0px, rgba(0, 0, 0, 0.02) 0px 3px 6px 0px, 0 0 0 100px rgb(255, 255, 255) inset'
    },
    _hover: {},
    border: '1px solid',
    borderColor: '#e6e6e6',
    borderRadius: '5px !important',
    color: 'navy.400',
    height: '39px'
};

export const labelStyles = {
    color: 'navy.400',
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 1.15,
    marginBottom: '4px'
};
